import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { IntlProvider } from 'react-redux-multilingual';
import translations from './translations';
import { getRoutes } from './lib/routes';
import store, { history } from './Store';
import { setAppInitialState } from './lib/utils';
import '../config/configuration';

// initial store state from server
setAppInitialState(store);

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider translations={translations}>
      <Router history={history} routes={getRoutes(store)} />
    </IntlProvider>
  </Provider>,
  document.getElementById('react-root'),
);



// WEBPACK FOOTER //
// ./src/App.js